/* eslint-disable */
import React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  if (value !== index) return null;

  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flex: '1 1 auto',
      }}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

export default TabPanel;
